(function() {
  define('tlhServicesGridClass',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesGridClass', []).factory('TlhGridClassService', [
      function() {
        var factory;
        factory = {};
        factory.getColumnClass = function(nbColumns, prefix) {
          if (prefix == null) {
            prefix = 'col-sm-';
          }
          return prefix + (function() {
            switch (nbColumns) {
              case '2':
                return '6';
              case '3':
                return '4';
              case '4':
                return '3';
              case '6':
                return '2';
              case '12':
                return '1';
              default:
                return '12';
            }
          })();
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=gridClass.js.map
;
